import { useTranslation } from 'react-i18next';

export const useLoginTranslation = () => useTranslation('login');
export const useShowsTranslation = () => useTranslation('shows');
